export const CR_SHOULD_SEND_TO_ID_VALIDATION_ACTION = {
    name: 'CR_SHOULD_SEND_TO_ID_VALIDATION_ACTION',
    action: (bank: string, fileType: string) => ({
        bank, fileType,
        type: CR_SHOULD_SEND_TO_ID_VALIDATION_ACTION.name,
    })
};

export const CR_VERIFY_VALIDATION_ID_RESPONSE_ACTION = {
    name: 'CR_VERIFY_VALIDATION_ID_RESPONSE_ACTION',
    action: (token: string) => ({
        token,
        type: CR_VERIFY_VALIDATION_ID_RESPONSE_ACTION.name,
    })
};

export const CR_RESEND_CURP_TO_ID_VALIDATION_ACTION = {
    name: 'CR_RESEND_CURP_TO_ID_VALIDATION_ACTION',
    action: (curp: string, token: string, loanApplicationToken: string) => ({
        curp, token, loanApplicationToken,
        type: CR_RESEND_CURP_TO_ID_VALIDATION_ACTION.name,
    })
};
